import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { companyService } from '../services/companyService';
import CompanyForm from '../components/CompanyForm';

const EditCompany: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data: company, isLoading, error } = useQuery({
    queryKey: ['company', id],
    queryFn: () => companyService.getCompany(id!),
    enabled: !!id
  });

  if (isLoading) {
    return (
      <div className="max-w-app mx-auto px-6 py-8">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  if (error || !company) {
    return (
      <div className="max-w-app mx-auto px-6 py-8">
        <div className="text-center">
          <p className="text-red-600">Ошибка загрузки компании</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-app mx-auto px-6 py-8">
      <CompanyForm mode="edit" company={company} />
    </div>
  );
};

export default EditCompany;
